import { Box, useMediaQuery } from '@mui/material'
import { useContext, useEffect, useState } from 'react'

import { BREAKPOINT_MIN_LG } from '../../../../../Theme/stylesUtil'
import { ContestCreateContext } from '../../context'
import { FavoriteOriginal } from './FavoriteOriginal'
import { JudgeInfo } from './JudgeInfo'
import { JudgeSocialLinks } from './JudgeSocialLinks'
import { TextFieldBlock } from './TextFieldBlock'

export const JudgeProfile = ({ judgeIndex, contestId, contest }) => {
  const { setValue, watch } = useContext(ContestCreateContext)
  const [favoriteMaps, setFavoriteMaps] = useState([])
  const [favoriteOriginalMaps, setFavoriteOriginalMaps] = useState([])
  const [newMaps, setNewMaps] = useState({})

  const judge = watch(`judges[${judgeIndex}]`)

  useEffect(() => {
    setFavoriteMaps(
      judge?.judge_favorite_maps.map((id) => {
        if (!!contest.relations.maps[id])
          return {
            ...contest.relations.maps[id],
            user: contest.relations.users[contest.relations.maps[id].user_id],
          }
        else return newMaps[id]
      }),
    )
    setFavoriteOriginalMaps(
      judge?.judge_original_maps.map((id) => {
        if (!!contest.relations.maps[id])
          return {
            ...contest.relations.maps[id],
            user: contest.relations.users[contest.relations.maps[id].user_id],
          }
        else return newMaps[id]
      }),
    )
  }, [
    contest.relations.maps,
    contest.relations.users,
    judge?.judge_favorite_maps,
    judge?.judge_original_maps,
    judgeIndex,
    newMaps,
    setFavoriteMaps,
  ])
  const handleChangeNetwork = (value, field) => {
    setValue(`judges[${judgeIndex}].profile[${field}]`, value, { shouldDirty: true })
  }

  const handleChangeValue = (field) => (value) => {
    setValue(`judges[${judgeIndex}].${field}`, value, { shouldDirty: true })
  }
  const saveMapCardToFav = (map, isOriginal) => {
    const maps = isOriginal ? favoriteOriginalMaps : favoriteMaps
    if (maps.length === 4) return
    const favMaps = [map, ...maps]
    setFavoriteMaps(favMaps)
    if (isOriginal) {
      setFavoriteOriginalMaps(favMaps)
    } else {
      setFavoriteMaps(favMaps)
    }
    if (!maps.some((obj) => obj.id === map.id)) {
      setNewMaps({ ...newMaps, [map.id]: map })
    }
    setValue(
      `judges[${judgeIndex}].${isOriginal ? 'judge_original_maps' : 'judge_favorite_maps'}`,
      favMaps.map((favMap) => favMap.id),
    )
  }
  const deleteMapCardFromFav = (map, isOriginal) => {
    const maps = isOriginal ? favoriteOriginalMaps : favoriteMaps
    if (maps.length === 0) return
    const favMaps = maps.filter((favMap) => favMap.id !== map.id)
    if (isOriginal) {
      setFavoriteOriginalMaps(favMaps)
    } else {
      setFavoriteMaps(favMaps)
    }
    setValue(
      `judges[${judgeIndex}].${isOriginal ? 'judge_original_maps' : 'judge_favorite_maps'}`,
      favMaps.map((favMap) => favMap.id),
    )
  }

  const isBiggerThanLGScreen = useMediaQuery(BREAKPOINT_MIN_LG)
  return (
    <Box
      width={isBiggerThanLGScreen ? 700 : '100%'}
      display="flex"
      flexDirection="column"
      gap={3}
    >
      <JudgeInfo
        judge={judge}
        judgeIndex={judgeIndex}
        handleChangeRounds={handleChangeValue('rounds')}
        handleChangeRole={handleChangeValue('role')}
        handleChangeStatus={handleChangeValue('status')}
        contestId={contestId}
        roundLimits={contest.round_limits}
      />
      <JudgeSocialLinks
        judge={judge}
        judgeIndex={judgeIndex}
        handleChange={handleChangeNetwork}
      />
      <TextFieldBlock
        title={'Bio'}
        minRows={3}
        value={judge?.bio || ''}
        isMultiline
        onChange={handleChangeValue('bio')}
        placeholder="Briefly describe yourself, your gaming background, and experience with Halo. Mention any notable accomplishments or roles you've had in the gaming community. 
        500-1000 characters"
      />
      <TextFieldBlock
        title={'Map design preferences'}
        minRows={3}
        value={judge?.design_preferences || ''}
        isMultiline
        onChange={handleChangeValue('design_preferences')}
        placeholder="Summarize your preferred map styles, features, or themes for Halo Infinite, such as small vs. large maps, symmetrical vs. asymmetrical layouts, or specific environmental settings, etc
        100-300 characters"
      />
      <TextFieldBlock
        title={'What I love about Halo'}
        minRows={3}
        value={judge?.love_about_halo || ''}
        isMultiline
        onChange={handleChangeValue('love_about_halo')}
        placeholder="Share what aspects of the Halo franchise resonate with you the most, such as gameplay mechanics, storylines, or the community itself.
        300-500 characters"
      />
      <FavoriteOriginal
        favoriteMaps={favoriteOriginalMaps}
        deleteMapCardFromFav={deleteMapCardFromFav}
        saveMapCardToFav={saveMapCardToFav}
        isOriginal={true}
      />
      <FavoriteOriginal
        favoriteMaps={favoriteMaps}
        deleteMapCardFromFav={deleteMapCardFromFav}
        saveMapCardToFav={saveMapCardToFav}
        isOriginal={false}
      />
    </Box>
  )
}
